import Head from 'next/head';
import PropTypes from 'prop-types';
import { NextSeo } from 'next-seo';
import Items from '@cont/Saved/Items';
import { useSelectorToStore } from '@hooks/reduxHooks';
import { fetchTopologyInfo } from '@actions/topologies';
import { fetchSavedEntities } from '@actions/saved';
import { useSetSelectedNav } from '@stores/sidenav';
import { savedObjectTypes } from '@constants/index';
import setupInitialProps from '@utils/setupInitialProps';
import Layout from '@layout/index';
import escape from '@utils/escapeHTML';
import PageReduxProvider from '@cont/App/PageReduxProviderWrapper';

const Tests = ({ goalUID }) => {
  const goalInfo = useSelectorToStore(
    ({ topologies }) => topologies.topologyDetails[goalUID]
  );
  const { goalSlug, title, uid } = goalInfo;
  const goalTitle = 'My Saved Tests';
  const goalDescription = ` Prepare live from Top Educators with comprehensive, structured, and crash courses along with practice section for ${title} on Unacademy Plus.`;
  const canonicalURL = `https://unacademy.com/goal/${goalSlug}/${uid}/tests`;
  const imageURL =
    'https://static.uacdn.net/static/dist/c76c2e18c7980818a913f9467c74c567.png';

  useSetSelectedNav('saved');

  return (
    <>
      <NextSeo
        title={goalTitle}
        description={goalDescription}
        openGraph={{
          title: goalTitle,
          description: goalDescription,
          images: [
            {
              url: imageURL
            }
          ],
          url: canonicalURL
        }}
      />
      <Head>
        <title>{goalTitle}</title>
      </Head>
      <Items title="Tests" entityType={savedObjectTypes.TEST} />
    </>
  );
};

Tests.pageInfo = {
  isMWebSupported: true,
  name: 'Saved Tests List',
  layoutOptions: {
    showPlusNav: true
  }
};

export default Tests;

Tests.getInitialProps = setupInitialProps(
  async ({ store, query, isServer }) => {
    const { goalUID } = query;
    const promises = [];

    if (!store.getState().topologies?.topologyDetails?.[goalUID])
      promises.push(store.dispatch(fetchTopologyInfo(goalUID)));

    const dataKey = `${goalUID}-tests`;

    if (!store.getState().paginator?.saved?.[dataKey]?.loaded)
      promises.push(
        store.dispatch(
          fetchSavedEntities({ goalUid: goalUID, entityType: 2, key: dataKey })
        )
      );
    if (promises.length) await Promise.all(promises);
    return {
      isServer,
      goalUID: escape(goalUID)
    };
  },
  Tests.pageInfo
);

Tests.propTypes = {
  goalUID: PropTypes.string.isRequired
};
Tests.Layout = Layout;
Tests.Wrapper = PageReduxProvider;
